_collow.components.Course = class Course extends _collow.components.Base {
  root;
  elements;
  params;
  registrationId;

  constructor(root, elements, params) {
    super();

    this.root = root;
    this.elements = elements;
    this.params = params;

    [elements.topNextButton, elements.bottomNextButton]
      .filter((el) => el)
      .forEach((button) => this.listen(button, "click", this.nextClickHandler));

    this.listen(root, "_collow.quiz-finished", this.processQuiz);
    this.listen(root, "_collow.course-toggle-nav", () =>
      elements.nav.toggleAttribute("hidden")
    );

    this.registrationId = localStorage.getRegistrationId();

    this.listen(
      document.body,
      "_collow.not-logged-in",
      () => (window.location.pathname = "login")
    );

    this.listen(
      document.body,
      "_collow.course-completed",
      () => (this.root.dataset.courseFinished = "")
    );

    this.handleFileDownload()
  }

  /** api call to update the progress of the user */
  apiCallProgress = async (formData) => {
    const progressPath = this.params.currentLink.slice(
      this.params.currentLink.indexOf("/") + 1
    );
    formData.append("path", progressPath);
    return await fetch(
      this.params.path + `/course_registration/${this.registrationId}/element`,
      {
        method: "post",
        headers: {
          Authorization: localStorage.getItem("token"),
        },
        body: formData,
      }
    ).catch((err) => console.log(err));
  };

  nextClickHandler = async () => {
    const formData = new FormData();
    const res = await this.apiCallProgress(formData);
    const resJson = await res.json();

    if (res.ok) {
      this.updateLocalJson(resJson).then((resp) => {
        if (resp == "succes") window.location.pathname = this.params.nextLink;
      });
    }
    // TODO update error codes
    if (res.status == 401) {
      window.location.pathname = "login";
    }
  };

  updateLocalJson = async (resJson) => {
    const slashIndex = this.params.currentLink.indexOf("/");
    const courseName = this.params.currentLink.slice(0, slashIndex);
    const courseIndex = this.params.nextLink.indexOf("course");
    const tempLink = this.params.nextLink.slice(courseIndex + 7);
    const nextLink = tempLink.slice(tempLink.indexOf("/"));

    const progressJson = localStorage.getProgressJson();

    const courseProgress = progressJson["course_registrations"].map(
      (course) => {
        if (course.course["unique_identifer"] == courseName) {
          course["last_course_registration_element"] = resJson;
          if (!course["next_element"]) course["next_element"] = {};
          course["next_element"].path = nextLink;
        }
        return course;
      }
    );
    progressJson["course_registrations"] = courseProgress;
    localStorage.setItem("progressJson", JSON.stringify(progressJson));
    return "succes";
  };

  /** On finish quiz get all the points scored */
  processQuiz = ({ detail }) => {
    const formData = new FormData();
    formData.append("max_points", detail.max_points);
    formData.append("min_points", detail.min_points);
    formData.append("points", detail.points);
    formData.append("status", detail.status);

    this.apiCallProgress(formData);
    this.updateLocalJson();
  };

  /**
   Attaches click event listeners to all course file download links. Prevents the default behavior and triggers the downloadFile 
   method to handle the file download using JavaScript.
 */
  handleFileDownload = () => {
    const ancors = document.querySelectorAll(".course-lesson__file")
    if(ancors) {
      ancors.forEach(ancor => ancor.addEventListener("click", (event) => {
        event.preventDefault();

        const fileUrl = ancor.href
        const fileName = ancor.textContent
        this.downloadFile(fileUrl, fileName)
      }))
    }
  }

  /**
   Downloads a file from a given URL by creating a temporary link element with the 'download' attribute set.
   This avoids CORS issues by letting the browser handle the download directly.
 */
  downloadFile = (fileUrl, fileName) => {
    try {
      const a = document.createElement('a');
      a.href = fileUrl;
      a.download = fileName;
      a.target = '_blank';
      a.rel = 'noopener';
      a.style.display = 'none';
      
      document.body.appendChild(a);
      a.click();
      
      setTimeout(() => {
        document.body.removeChild(a);
      }, 100);
    } catch (error) {
      console.error('Error downloading file:', error);
      window.open(fileUrl, '_blank', 'noopener');
    }
  }
};
